<template>
  <v-chart class="radar-chart" :option="radarChartOption"/>
</template>

<script setup>
import {ref, watch} from 'vue';
import {use} from 'echarts/core';
import {BarChart, RadarChart} from 'echarts/charts';
import {GridComponent, LegendComponent, TitleComponent, TooltipComponent} from 'echarts/components';
import {CanvasRenderer} from 'echarts/renderers';
import VChart from 'vue-echarts';

// 注册必要的 ECharts 组件
use([
  RadarChart,
  BarChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  CanvasRenderer,
  GridComponent
]);

//接收父组件传递的数据
const props = defineProps({
  dataAxis: Array,
  seriesData: Array
})

console.log(props.dataAxis,"======")
// 雷达图的配置
const radarChartOption = ref({
  title: {
    text: ''
  },
  tooltip: {
    show: false,
  },
  xAxis: {
    data: props.dataAxis,
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    }
  },
  yAxis: {
    type: 'value',
    axisLine: {
      show: false
    },
    axisLabel: {
      show: false
    }
  },
  series: [{
    name: '',
    type: 'bar',
    // 数据
    data: props.seriesData
  }]
});

//监听seriesData的变化，更新雷达图配置
watch(() => props.seriesData, (newSeriesData) => {
  radarChartOption.value.series[0].data = newSeriesData;
}, {
  deep: true,
  immediate: true
})
</script>
<style>
.radar-chart {
  //width: 80%;
  //height: 80%;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
